module.exports = __webpack_public_path__ + "static/media/co-working.e1340133.jpg";